
import React from 'react';

export default function Marquee() {
  const services = [
    'AI Workflow Automation',
    'Process Optimization',
    'Custom Integrations',
    'Internal AI Tools',
    'RPA Solutions',
    'Consulting + Implementation',
  ];

  // Duplicate the list to create a seamless loop
  const items = [...services, ...services, ...services];

  return (
    <div className="relative w-full overflow-hidden bg-[#080810] border-y border-white/[0.06] py-5">
      {/* Fade left */}
      <div
        className="absolute left-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(to right, #080810, transparent)' }}
      />
      {/* Fade right */}
      <div
        className="absolute right-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
        style={{ background: 'linear-gradient(to left, #080810, transparent)' }}
      />

      <div
        className="flex items-center gap-0 whitespace-nowrap"
        // Guard against an empty items array – fallback to a single empty string
        style={{
          animation: items.length ? 'marqueeScroll 30s linear infinite' : 'none',
        }}
      >
        {items.map((service, index) => (
          <div key={index} className="flex items-center gap-0 flex-shrink-0">
            <span
              className="text-[#8887A0] text-xs uppercase tracking-widest font-medium px-6"
              style={{ fontFamily: 'JetBrains Mono, monospace' }}
            >
              {service}
            </span>
            <span className="text-[#7B3FE4] text-xs opacity-60 flex-shrink-0">·</span>
          </div>
        ))}
      </div>

      {/* Inline CSS for the marquee animation */}
      <style jsx>{`
        @keyframes marqueeScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.333%);
          }
        }
      `}</style>
    </div>
  );
}
